module.exports = __webpack_public_path__ + "static/media/combat(7).79bf522b.PNG";